<script setup>

import { inject, ref, computed, watch } from 'vue';
import { 
	apiModifierInfosParametre,
	apiSupprimerParametres } from '@/services/ServiceModele.js';
import SelecteurTypeDonnee from '@/components/generiques/SelecteurTypeDonnee.vue';
import SelecteurTypeFormat from '@/components/generiques/SelecteurTypeFormat.vue';

const { parametre } = defineProps({
  parametre: Object
});

const afficherBarreFlottante = inject('afficherBarreFlottante');
const appelerApiModifModele = inject('appelerApiModifModele');
const getTypeDonnee = inject('getTypeDonnee');
const getTypeFormat = inject('getTypeFormat');
const getTypesFormat = inject('getTypesFormat');

const texteNom = ref(parametre.nom);
const texteLibelle = ref(parametre.libelle);
const selectionTypeDonnee = ref(getTypeDonnee(parametre.typeDonnee));
const selectionTypeFormat = ref(getTypeFormat(parametre.idTypeFormat));
const boutonMenu = ref(null);

const typesFormatProposes = computed(() => {
    if (parametre?.typeDonnee) {
        return getTypesFormat(parametre?.typeDonnee);
    } else {
        return null;
    }
});

watch(() => parametre, (param) => {
	texteNom.value = param?.nom;
	texteLibelle.value = param?.libelle;
	selectionTypeDonnee.value = getTypeDonnee(param?.typeDonnee);
	selectionTypeFormat.value = getTypeFormat(param?.idTypeFormat);
});

watch(() => parametre?.nom, (nom) => {
	texteNom.value = nom;
});

watch(() => parametre?.libelle, (libelle) => {
	texteLibelle.value = libelle;
});

watch(() => parametre?.typeDonnee, (typeDonnee) => {
	selectionTypeDonnee.value = getTypeDonnee(typeDonnee);
});

watch(() => parametre?.idTypeFormat, (idTypeFormat) => {
	selectionTypeFormat.value = getTypeFormat(idTypeFormat);
});

const itemsMenu = [
	{
		libelle: 'Supprimer',
		icones: ['fa fa-trash'],
		style: 'color: var(--couleur-supprimer); ',
		commande: () => {
			supprimer();
		}
	}
];

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenu, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function reinitialiserValeurs() {
	texteNom.value = parametre.nom;
	texteLibelle.value = parametre.libelle;
	selectionTypeDonnee.value = getTypeDonnee(parametre.typeDonnee);
	selectionTypeFormat.value = getTypeFormat(parametre.idTypeFormat);
}

function modifierNom() {
	const parametreModifie = { ...parametre };
	parametreModifie.nom = texteNom.value;
	appelerApiModifModele(apiModifierInfosParametre, parametreModifie, () => {
		reinitialiserValeurs();
	});
}

function modifierLibelle() {
	const parametreModifie = { ...parametre };
	parametreModifie.libelle = texteLibelle.value;
	appelerApiModifModele(apiModifierInfosParametre, parametreModifie, () => {
		reinitialiserValeurs();
	});
}

function modifierTypeDonnee(typeDonnee) {
	const parametreModifie = { ...parametre };
	parametreModifie.typeDonnee = typeDonnee;
	appelerApiModifModele(apiModifierInfosParametre, parametreModifie, () => {
		reinitialiserValeurs();
	});
}

function modifierTypeFormat(typeFormat) {
	const parametreModifie = { ...parametre };
	parametreModifie.idTypeFormat = typeFormat.id;
	appelerApiModifModele(apiModifierInfosParametre, parametreModifie, () => {
		reinitialiserValeurs();
	});
}

function supprimer() {
	appelerApiModifModele(apiSupprimerParametres, [parametre]);
}

</script>

<template>
	<div>
		<div class="detail-parametre">
			<label class="intitule">Nom :</label>
			<div class="zone-nom">
				<input type="text" spellcheck="false" class="saisie-nom" 
					v-model="texteNom" 
					@keyup.enter="modifierNom()"
					@blur="reinitialiserValeurs" />
				<button class="bouton fa-solid fa-caret-down" 
					ref="boutonMenu"
					@click.stop="basculerAffichageMenu" />
			</div>
			<label class="intitule">Libellé :</label>
			<input type="text" spellcheck="false" 
				v-model="texteLibelle" 
				@keyup.enter="modifierLibelle()"
				@blur="reinitialiserValeurs" />
			<label class="intitule">Type :</label>
			<SelecteurTypeDonnee 
				v-model:typeDonnee="selectionTypeDonnee" 
				:proposer-types-objets="false" 
				:desactive="false" 
				@modification="modifierTypeDonnee"
				@blur="reinitialiserValeurs" />
			<template v-if="typesFormatProposes">
				<label class="intitule">Format :</label>
				<SelecteurTypeFormat 
					v-model:typeFormat="selectionTypeFormat" 
					:type-donnee="parametre?.typeDonnee"
					:types-format-proposes="typesFormatProposes"
					@modification="modifierTypeFormat"
					@blur="reinitialiserValeurs" />		
			</template>
		</div>
	</div>
</template>

<style scoped>

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 2px;
}

.detail-parametre {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px;
	margin-top: 10px;
	margin-bottom: 20px;
	padding-left: 5px;
	align-items: start;
}

.zone-nom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.saisie-nom {
	margin-right: 2px;
	flex-grow: 1;
	min-width: 20px;
}

</style>